export default __webpack_public_path__ + "static/media/graph-dot.b116b86d.svg";